import * as React from 'react';
import { SVGProps } from 'react';

const IconRemoveFromComparisonSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 1h2v14H1V1zm14 2v2H9V3h6zM7 5H5v10h2V5zm2 4h2v6H9V9zm6 2h-2v4h2v-4z" />
  </svg>
);
export default IconRemoveFromComparisonSizeS;
